import { render, staticRenderFns } from "./TaskTab.vue?vue&type=template&id=22d4d75a&scoped=true&"
import script from "./TaskTab.vue?vue&type=script&lang=ts&"
export * from "./TaskTab.vue?vue&type=script&lang=ts&"
import style0 from "./TaskTab.vue?vue&type=style&index=0&id=22d4d75a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d4d75a",
  null
  
)

export default component.exports